import React,{useState} from 'react'
import { InputGroup, FormControl,Button } from 'react-bootstrap'
import styles from './Contact.module.css'

const Contact = () => {
  const[name, setName] = useState('')
  const[email, setEmail] = useState('')
  const[message, setMessage] = useState('')

  const submit = () =>{
    fetch('http://englishtutorial1.somee.com/api/ContactMessages/CreateContactMessage', 
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json, text/json"
      },
      body: JSON.stringify({
        "Name": name,
        "Email": email,
        "MessageText": message
      })
    })
    .finally(()=>{
      setName('');
      setEmail('')
      setMessage('')
    })
  }

  return (
    <div className="bg-light p-5">
      <div id="contact" className={styles.container}>
        <h3>Get In Touch</h3>
        <p className="lead">
         For more information about the book and the sale points, please don't hesitate to contact us!
        </p>
        <InputGroup className="mb-3">
          <InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1">
              <i className="fas fa-user"></i>
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            placeholder="Name"
            aria-label="Name"
            aria-describedby="basic-addon1"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </InputGroup>
        
        <InputGroup className="mb-3">
          <InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1">
              <i className="fas fa-envelope"></i>
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            placeholder="Email"
            aria-label="Email"
            aria-describedby="basic-addon1"
            value={email}
            onChange={e =>  setEmail(e.target.value)}
          />
        </InputGroup>

        <InputGroup className="mb-3">
          <InputGroup.Prepend>
           <InputGroup.Text>       
              <i className="fas fa-pencil-alt"></i>
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl 
            as="textarea" 
            aria-label="With textarea" 
            placeholder="Message"
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </InputGroup>

        <Button
          size="lg" block
          // type="submit"
          // value="Submit"
          className="btn btn-block btn-lg text-white" 
          style={{backgroundColor:"#98426a", color:"white", padding:"15px"}} 
          onClick={submit}
        >
              Submit
        </Button>
              
      </div>
    </div>
  )
}

export default Contact